import styled from 'styled-components'

const tabletLandscape = 'tablet-landscape'

export const SectionHeaderContainer = styled.div`
  width: 100%;
  padding-top: 24px;
  background-color: ${({ bxBgMobile }) => bxBgMobile};
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  max-width: 100%;

  ${props => props.theme.mediaQuery.up('mobile-landscape')} {
    padding-top: 32px;
  }

  ${props => props.theme.mediaQuery.up(tabletLandscape)} {
    padding: 0;
    background-color: #ffffff;
  }
`

export const SectionHeader = styled.h2`
  font-size: 20px;
  position: relative;
  top: -18px;
  padding: 0 12px;
  margin: 0px;
  color: rgb(51, 51, 51);
  background-color: ${({ hdBgMobile }) => hdBgMobile};

  ${props => props.theme.mediaQuery.up(tabletLandscape)} {
    padding: 0 24px;
    background-color: #ffffff;
  }
`